// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseAssociation } from './BaseAssociation';
import { BEComponent } from './BEComponent';
import { BEEntity } from './BEEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { AggregationExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/AggregationExtend';
/**
 * 聚合关系 实体类
 * 聚合关系
 */
export class Aggregation extends BaseAssociation {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 源实体（聚合方） 的ID */
  private _sourceEntity_ID: string;

  /** 获取：源实体（聚合方） 的ID */
  public get sourceEntity_ID() {
    return this._sourceEntity_ID;
  }

  /** 设置：源实体（聚合方） 的ID */
  public set sourceEntity_ID(value: string) {
    this._sourceEntity_ID = value;
  }

  /** 源实体（聚合方）  */
  private _sourceEntity: BEEntity;

  /** 获取：源实体（聚合方）  */
  public get sourceEntity() {
    return this._sourceEntity;
  }

  /** 设置：源实体（聚合方）  */
  public set sourceEntity(value: BEEntity) {
    this._sourceEntity = value;
    if (value !== null) {
      this.sourceEntity_ID = value.id;
    } else {
      this.sourceEntity_ID = '';
    }
  }

  /** 目标实体（被聚合方） 的ID */
  private _targetEntity_ID: string;

  /** 获取：目标实体（被聚合方） 的ID */
  public get targetEntity_ID() {
    return this._targetEntity_ID;
  }

  /** 设置：目标实体（被聚合方） 的ID */
  public set targetEntity_ID(value: string) {
    this._targetEntity_ID = value;
  }

  /** 目标实体（被聚合方）  */
  private _targetEntity: BEEntity;

  /** 获取：目标实体（被聚合方）  */
  public get targetEntity() {
    return this._targetEntity;
  }

  /** 设置：目标实体（被聚合方）  */
  public set targetEntity(value: BEEntity) {
    this._targetEntity = value;
    if (value !== null) {
      this.targetEntity_ID = value.id;
    } else {
      this.targetEntity_ID = '';
    }
  }

  constructor() {
    super();
    AggregationExtend.Init(this);
    this._component_ID = '';
    this._component = null;
    this._sourceEntity_ID = '';
    this._sourceEntity = null;
    this._targetEntity_ID = '';
    this._targetEntity = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Aggregation, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.sourceEntity_ID = element.sourceEntity_ID;
      if (hasReference && element.sourceEntity !== null) {
        this.sourceEntity = element.sourceEntity;
      }
      this.targetEntity_ID = element.targetEntity_ID;
      if (hasReference && element.targetEntity !== null) {
        this.targetEntity = element.targetEntity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    this.sourceEntity_ID = json.SourceEntity_ID;
    // if (json.SourceEntity !== null) {
    //   this.sourceEntity = BEEntity.Create(json.SourceEntity);
    // }
    this.targetEntity_ID = json.TargetEntity_ID;
    // if (json.TargetEntity !== null) {
    //   this.targetEntity = BEEntity.Create(json.TargetEntity);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    json.SourceEntity_ID = this.sourceEntity_ID;
    json.TargetEntity_ID = this.targetEntity_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): Aggregation {
    const aggregation = new Aggregation();
    aggregation.Deserialize(json);
    aggregation.json = json;
    return aggregation;
  }
}
